var _circle, _path, _path2, _path3, _path4, _line, _line2, _path5, _polyline, _polyline2, _line3, _path6, _path7, _line4, _line5, _line6, _line7, _line8, _line9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVo2Max(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    cx: 21.4,
    cy: 5.5,
    r: 2.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M6.5,30.8c0,0,3.4-5.1,4.5-12.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M3.6,30.8c0,0,4.7-6,5.3-14.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M2.9,31.1h4.3c0,0,0.9-0.1,0.9,0.9c0,1.1,0,4.3,0,4.3s0,1-1,1s-4.2,0-4.2,0S2,37.5,2,36.4s0-4.5,0-4.5S2.1,30.9,2.9,31.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M32.8,31.1H37c0,0,0.9-0.1,0.9,0.9c0,1.1,0,4.3,0,4.3s0,1-1,1s-4.2,0-4.2,0s-0.9,0.2-0.9-0.9s0-4.5,0-4.5S32,30.9,32.8,31.1z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 8.1,
    y1: 32.2,
    x2: 31.5,
    y2: 32.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 8.1,
    y1: 36.3,
    x2: 31.5,
    y2: 36.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M12.1,19.1l-5-5.7c0,0-0.5-0.5,0-1s0.8-0.7,0.8-0.7s0.5-0.4,1,0.2s5.1,6,5.1,6s0.4,0.4-0.2,0.9c-0.5,0.5-0.5,0.5-0.5,0.5S12.9,20,12.1,19.1z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    points: "21.1,12.5 18.8,14.8 12.7,15.8 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    points: "22.3,14.9 20,17.1 14.2,18.1 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 19.8,
    y1: 19.4,
    x2: 24.2,
    y2: 18.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M19.5,20.6L16,26.6l-1.6,2.7c0,0-0.9,1.4,0.4,2.5c0.6,0.2,1.7,0.1,2.9-1.4c0.7-1,0.8-1.3,1.1-2c0.3-0.7,1.1-2.6,2.6-3.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M19,14.2v-2.6c0,0-0.1-2.2,3-2.2c0.9,0,3.2-0.6,2.8,2.4c-0.3,2.4-0.4,5.2-0.4,5.2s0.1,1.5,0.4,2.4c0.3,0.8,0.3,1.2,0,2.3c-0.1,0.6-0.4,0.9,0.2,2.3c0.2,1,0.2,1,0.2,1s0,1.1,1.4,2c0.7,0.6,2.2,2.6,1.8,4.5c0,0.1-1.6,1.5-3.2-1.1c-0.9-1-0.7-0.8-1.5-1.8c-0.8-0.9-3.3-3.7-4.4-11.2"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 10.6,
    y1: 34.2,
    x2: 12.3,
    y2: 34.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 14.2,
    y1: 34.2,
    x2: 16,
    y2: 34.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 17.2,
    y1: 34.2,
    x2: 19,
    y2: 34.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 20.9,
    y1: 34.3,
    x2: 22.6,
    y2: 34.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 24.2,
    y1: 34.3,
    x2: 25.9,
    y2: 34.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    x1: 27.7,
    y1: 34.3,
    x2: 29.4,
    y2: 34.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVo2Max);
export default __webpack_public_path__ + "static/media/VO2Max.01f227e2415dc0dab7a6f49281e0afa1.svg";
export { ForwardRef as ReactComponent };